export class DocHubStripePaymentObj {
public amount : number;
public currency: string;
public clientSecret: string;
}
